const invisible = {
  "visibility": "hidden !important",
  "opacity": "0"
};

export { invisible };
